import { Routes, Route } from 'react-router-dom'
import { MainLayout } from '~/widgets/layout/main'
import { MinimalLayout, MinimalTabsLayout } from '~/widgets/layout/minimal'
import { ProtectedPage } from '~/features/auth/protected-page'
import { viewerModel } from '~/entities/viewer'
import NotFoundPage from './404'
import {
  ListBalancePage,
  ListBonusBalancePage,
  ListDebtBalancePage,
} from './Balance'
import { ListBankCardsPage } from './Balance/ListBankCardsPage'
import { ListBalanceHistoriesPage } from './BalanceHistories'
import { BookingCarPage } from './BookingCars/BookingCarPage'
import { BookingCarViewInspectionPage } from './BookingCars/BookingCarViewInspectionPage'
import { ListBookingCarsPage } from './BookingCars/ListBookingCarsPage'
import { ProtectedBookingCarsUnAuthPage } from './BookingCars/ProtectedBookingCarsUnAuthPage'
import { ListDebtsPage } from './Debt/ListDebtsPage'
import { ViewDebtPage } from './Debt/ViewDebtPage'
import { ListDriverOccupationsPage } from './DriverOccupations'
import { EmailVerifyPage } from './EmailVerify'
import { HomePage } from './Home'
import { DamagesInspectionsPage } from './Inspections/DamagesInspectionsPage'
import { ListInspectionsPage } from './Inspections/ListInspectionsPage'
import { ViewInspectionPage } from './Inspections/ViewInspectionPage'
import LoginPage from './login'
import { RefuelingPage } from './Refueling'
import { ProtectedRegistrationPage } from './Registration'
import { LeadRegistrationWrapperPage } from './Registration/LeadRegistrationWrapperPage'
import { RegistrationPage } from './Registration/RegistrationPage'
import { RegistrationWrapperPage } from './Registration/RegistrationWrapperPage'
import { SimplifiedRegistrationConfirmPage } from './Registration/SimplifiedRegistrationConfirmPage'
import { SimplifiedRegistrationPage } from './Registration/SimplifiedRegistrationPage'
import { RentalContractSigningPage } from './RentalContractSigning'
import { ListTaxiparksPage, ProtectedDriverPage } from './Taxiparks'
import { ListTaxiparksUnAuthPage } from './Taxiparks/UnAuth/ListTaxiparksUnAuthPage'
import { WorkSchedulePage } from './WorkSchedule'

export const Routing = () => {
  const authenticated = viewerModel.useAuthenticated()

  return (
    <Routes>
      <Route element={<ProtectedPage />}>
        <Route element={<ProtectedDriverPage />}>
          <Route element={<MainLayout />}>
            <Route path='/' element={<HomePage />} id={'home'} />

            <Route path='/work-schedule' element={<WorkSchedulePage />} />
            <Route path='/refueling' element={<RefuelingPage />} />

            <Route path='/debts' element={<ListDebtsPage />} />
            <Route path='/debts/:debtId' element={<ViewDebtPage />} />

            <Route path='/balance' element={<ListBalancePage />} />
            <Route path='/balance-bonus' element={<ListBonusBalancePage />} />
            <Route path='/balance-debt' element={<ListDebtBalancePage />} />
            <Route path='/bank-cards' element={<ListBankCardsPage />} />

            <Route
              path='/driver-occupations'
              element={<ListDriverOccupationsPage />}
            />

            <Route
              path='/balance-histories'
              element={<ListBalanceHistoriesPage />}
            />

            {authenticated && (
              <>
                <Route path='/booking-cars' element={<ListBookingCarsPage />} />
                <Route
                  path='/booking-cars/:bookingCarId'
                  element={<BookingCarPage />}
                />
                <Route
                  path='/booking-cars/:bookingCarId/inspections/:inspectionId'
                  element={<BookingCarViewInspectionPage />}
                />

                <Route
                  path='/registration'
                  element={<LeadRegistrationWrapperPage />}
                />
                <Route
                  path='/registration-manual'
                  element={<RegistrationPage />}
                />
              </>
            )}

            <Route path='/inspections' element={<ListInspectionsPage />} />
            <Route
              path='/inspections/:inspectionId'
              element={<ViewInspectionPage />}
            />
            <Route
              path='/inspections/:inspectionId/damages'
              element={<DamagesInspectionsPage />}
            />

            <Route
              path='/rental-contract-signing'
              element={<RentalContractSigningPage />}
            />
          </Route>
        </Route>

        {authenticated && (
          <>
            <Route path='/taxiparks' element={<ListTaxiparksPage />} />
            <Route path='/taxiparks-manual' element={<ListTaxiparksPage />} />
          </>
        )}
      </Route>

      <Route element={<MinimalLayout />}>
        <Route element={<MinimalTabsLayout />}>
          {!authenticated && (
            <>
              <Route element={<ProtectedBookingCarsUnAuthPage />}>
                <Route
                  path='/booking-cars'
                  element={<ListBookingCarsPage canBack={false} />}
                />
                <Route
                  path='/booking-cars/:bookingCarId'
                  element={<BookingCarPage />}
                />
              </Route>
            </>
          )}

          <Route path='/login' element={<LoginPage />} />
        </Route>
        <Route element={<ProtectedRegistrationPage />}>
          {!authenticated && (
            <>
              <Route
                path='/registration'
                element={<RegistrationWrapperPage />}
              />
              <Route
                path='/registration-manual'
                element={<RegistrationPage />}
              />
            </>
          )}
          <Route
            path='/simplified-registration'
            element={<SimplifiedRegistrationPage />}
          />
        </Route>
        <Route
          path='/simplified-registration-confirm'
          element={<SimplifiedRegistrationConfirmPage />}
        />
        {!authenticated && (
          <>
            <Route path='/taxiparks' element={<ListTaxiparksUnAuthPage />} />
            <Route
              path='/taxiparks-manual'
              element={<ListTaxiparksUnAuthPage isManualRegistration />}
            />
          </>
        )}

        <Route path='/email-verify' element={<EmailVerifyPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
